<template>
  <div>
    <!-- Unpermitted all users modals  -->
    <b-modal
      id="allAttendanceMode"
      hide-footer
      hide-header
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <UnpermittedAllAttendanceMode />
    </b-modal>

    <b-modal
      id="allExpected"
      hide-footer
      hide-header
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <UnpermittedAllExpected />
    </b-modal>

    <b-modal
      id="allHost"
      hide-footer
      hide-header
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <UnpermittedAllHost />
    </b-modal>

    <b-modal
      id="allExpectedNotToday"
      hide-footer
      hide-header
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <UnpermittedAllExpectedNotToday />
    </b-modal>

    <b-modal
      id="allUserType"
      hide-footer
      hide-header
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <UnpermittedAllUserType />
    </b-modal>

    <!-- Unpermitted and permitted users modals  -->
    <b-modal
      id="someAttendanceMode"
      hide-footer
      hide-header
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <UnpermittedAttendanceMode />
    </b-modal>

    <b-modal
      id="someExpected"
      hide-footer
      hide-header
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <UnpermittedExpected />
    </b-modal>

    <b-modal
      id="someExpectedNotToday"
      hide-footer
      hide-header
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <UnpermittedExpectedNotToday />
    </b-modal>

    <b-modal
      id="someHost"
      hide-footer
      hide-header
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <UnpermittedHost />
    </b-modal>

    <b-modal
      id="someUserType"
      hide-footer
      hide-header
      size="lg"
      scrollable
      no-close-on-backdrop
    >
      <UnpermittedUserType />
    </b-modal>
  </div>
</template>

<script>
import UnpermittedAllAttendanceMode from "@/router/views/dailylogUsersMassaction/modals/acl/UnpermittedAllUsers/AttendanceMode.vue";
import UnpermittedAllExpected from "@/router/views/dailylogUsersMassaction/modals/acl/UnpermittedAllUsers/Expected.vue";
import UnpermittedAllExpectedNotToday from "@/router/views/dailylogUsersMassaction/modals/acl/UnpermittedAllUsers/ExpectedNotToday.vue";
import UnpermittedAllHost from "@/router/views/dailylogUsersMassaction/modals/acl/UnpermittedAllUsers/Host.vue";
import UnpermittedAllUserType from "@/router/views/dailylogUsersMassaction/modals/acl/UnpermittedAllUsers/UserType.vue";

import UnpermittedAttendanceMode from "@/router/views/dailylogUsersMassaction/modals/acl/UnpermittedSomeUsers/AttendanceMode.vue";
import UnpermittedExpected from "@/router/views/dailylogUsersMassaction/modals/acl/UnpermittedSomeUsers/Expected.vue";
import UnpermittedExpectedNotToday from "@/router/views/dailylogUsersMassaction/modals/acl/UnpermittedSomeUsers/ExpectedNotToday.vue";
import UnpermittedHost from "@/router/views/dailylogUsersMassaction/modals/acl/UnpermittedSomeUsers/Host.vue";
import UnpermittedUserType from "@/router/views/dailylogUsersMassaction/modals/acl/UnpermittedSomeUsers/UserType.vue";

export default {
  components: {
    UnpermittedAllAttendanceMode,
    UnpermittedAllExpected,
    UnpermittedAllExpectedNotToday,
    UnpermittedAllHost,
    UnpermittedAllUserType,
    UnpermittedAttendanceMode,
    UnpermittedExpected,
    UnpermittedExpectedNotToday,
    UnpermittedHost,
    UnpermittedUserType,
  },
};
</script>
